import { render, staticRenderFns } from "./RealEstateBuildingComparisonView.vue?vue&type=template&id=2d860078&scoped=true&"
import script from "./RealEstateBuildingComparisonView.vue?vue&type=script&lang=js&"
export * from "./RealEstateBuildingComparisonView.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateBuildingComparisonView.vue?vue&type=style&index=0&id=2d860078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d860078",
  null
  
)

export default component.exports